import { render, staticRenderFns } from "./MarkAsReadButton.vue?vue&type=template&id=4e96f802&scoped=true"
import script from "./MarkAsReadButton.vue?vue&type=script&lang=js"
export * from "./MarkAsReadButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e96f802",
  null
  
)

export default component.exports